import React, { useCallback, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { Card, Checkbox, Dropdown, Space, Typography } from 'antd'
import { MoreOutlined } from '@ant-design/icons'
import cn from 'classnames'

import WhatsappIcon from 'assets/images/whatsapp-fill.svg?react'
import EmailIcon from 'assets/images/email-fill.svg?react'
import styles from './methods.module.scss'

const { Text } = Typography

const Methods = ({
  advanceWhatsApp,
  isMass,
  methods,
  onMethodToggle,
  onSelectedMethodChange,
  selectedMethod,
  setAdvanceWhatsApp,
}) => {
  const { formatMessage } = useIntl()
  const onClickWhatsAppCheckbox = useCallback(
    (e) => {
      e.stopPropagation()
      onMethodToggle('WhatsApp')
      onSelectedMethodChange('WhatsApp')
    },
    [onMethodToggle, onSelectedMethodChange],
  )

  const onClickEmailCheckbox = useCallback(
    (e) => {
      e.stopPropagation()
      onMethodToggle('Email')
      onSelectedMethodChange('Email')
    },
    [onMethodToggle, onSelectedMethodChange],
  )

  const menu = useMemo(() => {
    if (advanceWhatsApp) {
      return {
        items: [{ label: 'Simple', key: 'simple', onClick: () => setAdvanceWhatsApp(false) }],
      }
    }

    return {
      items: [{ label: 'Advance', key: 'advance', onClick: () => setAdvanceWhatsApp(true) }],
    }
  }, [advanceWhatsApp, setAdvanceWhatsApp])

  return (
    <div className={styles.methodSection}>
      <div className="d-flex align-items-center justify-content-between">
        <Text className={styles.methodTitle}>
          {formatMessage({ id: 'financeInvoices.select_sending_method' })}
        </Text>
        {!isMass && selectedMethod === 'WhatsApp' && (
          <Dropdown arrow menu={menu} trigger={['click']} placement="bottomRight">
            <MoreOutlined style={{ fontSize: 20 }} />
          </Dropdown>
        )}
      </div>
      <Space size={16} className={styles.methodOptions}>
        <Card
          className={cn(
            styles.methodCard,
            selectedMethod === 'WhatsApp' ? styles.methodCardSelected : '',
          )}
          onClick={() => onSelectedMethodChange('WhatsApp')}
        >
          <div className={styles.methodCardContent}>
            <div className={styles.methodCardText}>
              <WhatsappIcon className={`${styles.methodIcon} ${styles.whatsappIcon}`} />
              <div className={styles.methodTextContent}>
                <Text className={styles.methodName}>WhatsApp</Text>
                <Text className={styles.methodDesc}>
                  {formatMessage({ id: 'financeInvoices.quick_response' })}
                </Text>
              </div>
            </div>
            <Checkbox
              checked={methods.includes('WhatsApp')}
              className={styles.methodCheckbox}
              onClick={onClickWhatsAppCheckbox}
            />
          </div>
        </Card>
        <Card
          className={cn(
            styles.methodCard,
            selectedMethod === 'Email' ? styles.methodCardSelected : '',
          )}
          onClick={() => onSelectedMethodChange('Email')}
        >
          <div className={styles.methodCardContent}>
            <div className={styles.methodCardText}>
              <EmailIcon className={`${styles.methodIcon} ${styles.emailIcon}`} />
              <div className={styles.methodTextContent}>
                <Text className={styles.methodName}>Email</Text>
                <Text className={styles.methodDesc}>
                  {formatMessage({ id: 'financeInvoices.formal_professional' })}
                </Text>
              </div>
            </div>
            <Checkbox
              checked={methods.includes('Email')}
              className={styles.methodCheckbox}
              onClick={onClickEmailCheckbox}
            />
          </div>
        </Card>
      </Space>
    </div>
  )
}

export default Methods
